import React, { useMemo } from 'react';
import sanitizeHtml from 'sanitize-html';

export const sanitizeInput = (
    value: string,
    allowedTags: string[],
    allowedAttributes: sanitizeHtml.IOptions['allowedAttributes']
) =>
    sanitizeHtml(value, {
        allowedTags,
        allowedAttributes,
    });

export const descriptionTags = ['a', 'h1', 'h2', 'h3', 'b', 'i', 'em', 'strong', 'p', 'ul', 'ol', 'li', 'ins', 'del'];

export const descriptionAttributes: sanitizeHtml.IOptions['allowedAttributes'] = {
    a: ['target', 'href', 'rel'],
};

export interface InnerHtmlI {
    value?: string;
    allowedTags?: string[];
    allowedAttributes?: sanitizeHtml.IOptions['allowedAttributes'];
}

export const InnerHtml = ({ value, allowedTags = [], allowedAttributes = {} }: InnerHtmlI) => {
    const sanitizedValue = useMemo(() => {
        if (typeof value === 'string') {
            return sanitizeInput(value, allowedTags, allowedAttributes);
        }

        return '';
    }, [value, allowedTags, allowedAttributes]);

    return (
        // eslint-disable-next-line react/no-danger
        <div dangerouslySetInnerHTML={{ __html: sanitizedValue }} />
    );
};